import React from 'react';
import { BookOpen, Users, Brain, Sparkles, Target, FileText, Clock, CheckCircle, BarChart3, Share2 } from 'lucide-react';

const BenefitsGrid = ({ isDarkMode }) => {
  const studentBenefits = [
    { icon: Brain, title: 'Active Recall over Passive Reading', desc: 'Transform passive studying into active learning' },
    { icon: Sparkles, title: 'Instant AI Question Solver', desc: 'Step-by-step explanations for any problem' },
    { icon: Target, title: 'Personalized Weak Spot Detection', desc: 'AI identifies exactly what you need to work on' },
    { icon: FileText, title: 'Offline PDF & Audio Support', desc: 'Study anywhere, even without internet' }
  ];

  const teacherBenefits = [
    { icon: Clock, title: '90% Reduction in Prep Time', desc: 'Create assessments in seconds, not hours' },
    { icon: CheckCircle, title: 'Instant Rubrics & Auto-Grading', desc: 'Save time with automated scoring' },
    { icon: BarChart3, title: 'Classroom Diagnostics', desc: 'Topic mastery heatmaps at a glance' },
    { icon: Share2, title: 'Multi-Format Sharing', desc: 'PDF, web link, WhatsApp, Google Classroom' }
  ];

  return (
    <section data-testid="section-benefits-dual" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className={`inline-block text-xs uppercase tracking-[0.25em] font-bold mb-4 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`}>Why AIQuizPark</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-['Outfit'] tracking-tight mb-4">
            Built for Results
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {/* Student Benefits */}
          <div className={`rounded-2xl p-6 sm:p-8 ${isDarkMode ? 'bg-sky-900/20 border border-sky-700/50' : 'bg-sky-50 border border-sky-200'}`}>
            <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-6 ${isDarkMode ? 'bg-sky-900/50 text-sky-400' : 'bg-sky-100 text-sky-700'}`}>
              <BookOpen className="w-4 h-4" />
              Student Benefits
            </div>
            <ul className="space-y-4">
              {studentBenefits.map((item, i) => (
                <li key={i} className="flex items-start gap-4">
                  <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center ${isDarkMode ? 'bg-sky-900/50' : 'bg-sky-100'}`}>
                    <item.icon className={`w-5 h-5 ${isDarkMode ? 'text-sky-400' : 'text-sky-600'}`} />
                  </div>
                  <div>
                    <h4 className={`font-bold mb-1 ${isDarkMode ? 'text-sky-300' : 'text-sky-800'}`}>{item.title}</h4>
                    <p className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Teacher Benefits */}
          <div className={`rounded-2xl p-6 sm:p-8 ${isDarkMode ? 'bg-emerald-900/20 border border-emerald-700/50' : 'bg-emerald-50 border border-emerald-200'}`}>
            <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-6 ${isDarkMode ? 'bg-emerald-900/50 text-emerald-400' : 'bg-emerald-100 text-emerald-700'}`}>
              <Users className="w-4 h-4" />
              Teacher Benefits
            </div>
            <ul className="space-y-4">
              {teacherBenefits.map((item, i) => (
                <li key={i} className="flex items-start gap-4">
                  <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center ${isDarkMode ? 'bg-emerald-900/50' : 'bg-emerald-100'}`}>
                    <item.icon className={`w-5 h-5 ${isDarkMode ? 'text-emerald-400' : 'text-emerald-600'}`} />
                  </div>
                  <div>
                    <h4 className={`font-bold mb-1 ${isDarkMode ? 'text-emerald-300' : 'text-emerald-800'}`}>{item.title}</h4>
                    <p className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsGrid;
